module.exports = __webpack_public_path__ + "img/img_08_retail@3x.2dc41985.png";